"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate_iptu = exports.mask_iptu = exports.create_iptu = void 0;
var validate_1 = require("./validate");
var mask_1 = require("./mask");
var utils_1 = require("../utils");
var create_1 = require("./create");
exports.create_iptu = function (number, estado, cidade) {
    if (!create_1.IPTUCREATE[estado] || !create_1.IPTUCREATE[estado][cidade]) {
        return true;
    }
    number = utils_1.getAllDigits(number);
    return create_1.IPTUCREATE[estado][cidade](number);
};
exports.mask_iptu = function (number, estado, cidade) {
    if (!mask_1.IPTUMASKS[estado] || !mask_1.IPTUMASKS[estado][cidade]) {
        return number;
    }
    return mask_1.IPTUMASKS[estado][cidade];
};
exports.validate_iptu = function (number, estado, cidade) {
    if (!validate_1.IPTUVALIDATE[estado] || !validate_1.IPTUVALIDATE[estado][cidade]) {
        return true;
    }
    number = utils_1.getAllDigits(number);
    return validate_1.IPTUVALIDATE[estado][cidade](number);
};
//# sourceMappingURL=iptu.js.map